/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from '../../mutation-types';

const state = {
  vehicles: [],
  error: null,
};

const getters = {
  vehicles: state => state.vehicles,
  error: state => state.error,
};

const actions = {
  fetch({ commit }, payload) {
     return Vue.http.get(`${process.env.BACKEND_API_URL}api/user/${payload.id}/vehicle`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      })
      .catch((error) => {
        console.log(error, 'failed to fetch vehicles');
      });
  },
  delete({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/vehicles/${payload.id}`)
      .then(() => {
        commit(mTypes.DATA_ERROR, null);
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  saveVehicle({ commit }, payload) {
    const path = `users/${payload.user.data.selectedRole.id}`;
    let request;
    if (payload.vehicle.id) {
      request = Vue.http.put(`${process.env.BACKEND_API_URL}api/${path}/vehicles/${payload.vehicle.id}`, payload.vehicle);
    } else {
      request = Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/vehicles/`, payload.vehicle);
    }
    request.then((response) => {
      commit(mTypes.DATA_STORED, JSON.parse(response.bodyText));
    })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
    return request;
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, vehicles) {
    state.vehicles = vehicles.data;
    state.error = null;
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error;
  },
  [mTypes.CLEAR_STATE](state) {
    state.vehicles = [];
  },
  [mTypes.DATA_STORED](state, vehicle) {
    state.error = null;
    const index = state.vehicles.items.findIndex(obj => obj.id === vehicle.id);
    if (index >= 0) {
      // state.vehicles.items[index] = vehicle;
      Vue.set(state.vehicles.items, index, vehicle);
    } else {
      state.vehicles.items.push(vehicle);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/users/vehicles.js